import React, { useEffect } from 'react';
import { useTypedTranslation } from '@app/hooks';

interface IProps {
    checkValidation: Function;
}

interface IData {
    Deny: boolean;
}

export const DenyAccess = (props: IProps) => {
    const { checkValidation } = props;
    const { translation } = useTypedTranslation();

    useEffect(() => {
        const data: IData = {
            Deny: true
        };
        checkValidation(true, data);
    }, []);

    return (
        <div className=''>
            <h3>{translation('AUTH_POLICY_DENY_ALL')}</h3>
            <p>{translation('AUTH_POLICY_DENY_ALL_DESC')}</p>
        </div>
    );
};
